export const DEFAULT = {
    type: "FREQUENCY_VS_LEVEL",
    data: { mirrored: true, coloration: "RAINBOW" },
};
export const NONE = {
    type: "NONE",
};
